import { ChainId } from '@pancakeswap/sdk'

export const SUPPORT_ONLY_BSC = [ChainId.BSC]
export const SUPPORT_FARMS = [ChainId.BSC, ChainId.BSC_TESTNET]

export const SUPPORT_ZAP = [ChainId.BSC, ChainId.BSC_TESTNET]
